/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Form_LabelInputs */



/**
* | output |
* | --- |
* | "CLI Tools Configuration" |
*
* @param {Options_Cli_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_form_label = /** @type {((inputs?: Options_Cli_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration des outils CLI")
	if (locale === "de") return /** @type {LocalizedString} */ ("CLI-Tools-Konfiguration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione degli strumenti CLI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка инструментов командной строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de herramientas CLI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CLI 工具配置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CLIツールの設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CLI टूल्स कॉन्फ़िगरेशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração de ferramentas de linha de comando")
	return /** @type {LocalizedString} */ ("CLI Tools Configuration")
});